import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Configs from "../helpers/config";
import history from "../store/history";
import { logout } from "../store/modules/auth";

import { Button, Grid, Image } from "semantic-ui-react";
import { application_agnostic_auth_token } from "./Login";

const Cabecalho = (props) => {
    const [token, setToken] = React.useState();

    React.useEffect(() => {
        const tk = localStorage.getItem(application_agnostic_auth_token);

        if (tk) setToken(JSON.parse(tk));
    }, [props, props.auth]);

    return (
        <Grid.Row>
            <Grid.Row>
                <Grid columns={3}>
                    <Grid.Row>
                        <Grid.Column width={5}>
                            <Image src={require("../img/logo_topo.png")} className="imgLogoCabecalho" verticalAlign="middle" />
                        </Grid.Column>
                        <Grid.Column width={11} verticalAlign="middle" floated="right">
                            <div style={{ float: "right" }}>
                                {token?.type === "medico" && <Button href={Configs.CONSULTORIO_URL}>Portal Consultorios</Button>}
                                {/* Login normal */}
                                {props.auth.authenticated && !props.auth.portal ? (
                                    <>
                                        <Button
                                            content={props.auth.user || "Alterar email/senha"}
                                            icon="edit"
                                            labelPosition="right"
                                            onClick={() => history.push("/alterarSenha")}
                                        />
                                        <Button icon="sign out" onClick={() => history.push("/")} />
                                    </>
                                ) : null}
                                {/* Login tokem medico portal */}
                                {props.auth.authenticated && props.auth.portal ? (
                                    <>
                                        <Button content={props.auth.user} icon="lock" labelPosition="right" />
                                        <Button icon="sign out" onClick={() => history.push("/")} />
                                    </>
                                ) : null}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched className="containers1">
                        <Grid.Column floated="right" className="tst">
                            <Image src={require("../img/iconeCabecalho2.png")} className="iconeCabecalho" />
                        </Grid.Column>
                        <Grid.Column className="columnCabeçalhoSpan">
                            <span className="span1">resultados de </span>
                            <span className="span2">exames</span>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row only="computer" className="containers2">
                        <span className="textoCabecalho">
                            Para acessar seus resultados de exames entre com a identificação e senha disponíveis no seu talão de exame.
                        </span>
                    </Grid.Row>
                </Grid>
            </Grid.Row>
        </Grid.Row>
    );
};

const mapStateToProps = (state) => ({ auth: state.auth, routing: state.routing });
const mapDispatchToProps = (dispatch) => bindActionCreators({ logout }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Cabecalho);
